var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.82144 4.80176C9.21987 4.80176 8.73047 5.29148 8.73047 5.89344C8.73047 6.49485 9.21987 6.98414 9.82144 6.98414C10.423 6.98414 10.9124 6.49485 10.9124 5.89344C10.9124 5.29148 10.423 4.80176 9.82144 4.80176Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82111 8.62012C9.36926 8.62012 9.00293 8.98644 9.00293 9.4383V14.3474C9.00293 14.7992 9.36926 15.1656 9.82111 15.1656C10.273 15.1656 10.6393 14.7992 10.6393 14.3474V9.4383C10.6393 8.98644 10.273 8.62012 9.82111 8.62012Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.75292,
    cy: 9.74804,
    r: 8.24804,
    stroke: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b69be9993127d6855baa749baf2c3277.svg";
export { ForwardRef as ReactComponent };